var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{'bg-checkered': _vm.isOpacitySet || _vm.hasColorTransparency}},[_c('div',{style:(_vm.elementStyle)})])
}
var staticRenderFns = []

export { render, staticRenderFns }